import React from "react";
import { getUniqueExercises } from "./blockHelpers";

const BlocksComponent = ({ program, programExercises }) => {
  const notSingleWorkout = program.storeType !== "single-workout";

  const renderBlocks = (blocks) => {
    const uniqueExercises =
      programExercises && programExercises.exercises
        ? getUniqueExercises(programExercises.exercises)
        : null;

    return blocks.map((block) => {
      const blockExercises = uniqueExercises
        ? uniqueExercises[block.order]
        : [];

      return (
        <article key={`Block ${block.order}-${block.name}`}>
          <p className="s1">{notSingleWorkout ? block.name : "Exercises"}:</p>

          {blockExercises && blockExercises.length > 0 ? (
            <ul>
              {blockExercises.map((exercise) => (
                <li key={exercise}>
                  <p>{exercise}</p>
                </li>
              ))}
            </ul>
          ) : (
            <span className="no-exercises">
              No exercises found for this{" "}
              {notSingleWorkout ? "block" : "workout"}
            </span>
          )}
        </article>
      );
    });
  };

  return program.programs && program.programs.length > 0 ? (
    renderBlocks(program.programs)
  ) : (
    <div className="block-card">
      <p className="s1">No blocks found for this program</p>
    </div>
  );
};

export default BlocksComponent;
